import React from "react";
import { Modal, Paper, Tooltip } from "@mui/material";
import styled from "styled-components";
import { useLocalParticipant } from "../../hooks/useLocalParticipant";

import noneImage from "../../assets/images/effects/none.png";
import blurImage from "../../assets/images/effects/blur.png";
import livingRoomImage from "../../assets/images/effects/living_room.jpg";
import officeImage from "../../assets/images/effects/office.jpg";
import { UploadIcon } from "../icons/UploadIcon/UploadIcon";

const EffectsModal: React.FC = () => {
  const { showEffectsModal, setShowEffectsModal, handleChangeBackground } = useLocalParticipant();

  const imageInputRef = React.useRef<HTMLInputElement>(null);

  const onSelectImage = (e: React.ChangeEvent<HTMLInputElement>) => {
    if (!e.target.files || e.target.files.length <= 0) {
      return;
    }
    handleChangeBackground(URL.createObjectURL(e.target.files[0]));
  };

  return (
    <Modal open={showEffectsModal} disableEscapeKeyDown={true}>
      <Container>
        <Header>
          <Title>Alterar plano de fundo da câmera</Title>
        </Header>
        <Content>
          <Tooltip title={"Nenhum"} arrow={true}>
            <EffectButton onClick={() => handleChangeBackground(null)}>
              <ButtonImageSmall src={noneImage} />
            </EffectButton>
          </Tooltip>
          <Tooltip title={"Carregar imagem de fundo"} arrow={true}>
            <EffectButton onClick={() => imageInputRef.current?.click()}>
              <UploadIcon />
              <input
                ref={imageInputRef}
                type={"file"}
                accept={"image/*"}
                onChange={onSelectImage}
                style={{ display: "none" }}
              />
            </EffectButton>
          </Tooltip>
          <Tooltip title={"Borrar fundo"} arrow={true}>
            <EffectButton onClick={() => handleChangeBackground("blur")}>
              <ButtonImageSmall src={blurImage} />
            </EffectButton>
          </Tooltip>
          <Tooltip title={"Sala de estar"} arrow={true}>
            <EffectButton onClick={() => handleChangeBackground("livingRoom")}>
              <ButtonImage src={livingRoomImage} />
            </EffectButton>
          </Tooltip>
          <Tooltip title={"Escritório"} arrow={true}>
            <EffectButton onClick={() => handleChangeBackground("office")}>
              <ButtonImage src={officeImage} />
            </EffectButton>
          </Tooltip>
        </Content>
        <Footer>
          <CloseButton onClick={() => setShowEffectsModal(false)}>Fechar</CloseButton>
        </Footer>
      </Container>
    </Modal>
  );
};

export default EffectsModal;

const Container = styled(Paper)`
  display: flex;
  flex-direction: column;
  left: 50%;
  max-width: 90%;
  position: absolute;
  top: 50%;
  transform: translate(-50%, -50%);
  width: 450px;
`;

const Header = styled.div`
  align-items: center;
  border-bottom: 1px solid #e9ecef;
  display: flex;
  justify-content: center;
  padding: 16px;
`;

const Title = styled.div`
  color: #4c5667;
  font-size: 18px;
`;

const Content = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
  justify-content: center;
  padding: 16px;
`;

const EffectButton = styled.button`
  all: unset;
  align-items: center;
  aspect-ratio: 1;
  border: 1px solid #c5c5c5;
  border-radius: 4px;
  cursor: pointer;
  display: flex;
  height: 64px;
  justify-content: center;
`;

const ButtonImage = styled.img`
  height: 100%;
  object-fit: cover;
  width: 100%;
`;

const ButtonImageSmall = styled.img`
  height: 80%;
  object-fit: contain;
  width: 80%;
`;

const Footer = styled.div`
  align-items: center;
  border-top: 1px solid #e9ecef;
  display: flex;
  justify-content: flex-end;
  padding: 8px;
`;

const CloseButton = styled.button`
  background-color: rgb(226, 38, 38);
  border: none;
  border-radius: 4px;
  color: #ffffff;
  cursor: pointer;
  height: 38px;
  padding: 0 32px;
  transition: background-color 0.2s;

  :hover {
    background-color: rgb(206, 37, 37);
  }
`;
